import { mapRanges } from './mapRanges';
import { updateRangesRelativeValues } from './updateRangesRelativeValues';
export function updateRanges(spectrum) {
    spectrum.ranges.values = mapRanges(spectrum.ranges.values, spectrum, {
        checkIsExisting: false,
        shiftTarget: 'current',
    });
    updateRangesRelativeValues(spectrum, true);
}
//# sourceMappingURL=updateRanges.js.map